import React, { Component } from 'react';
import validate from "../../utils/validations";
import PropTypes from "prop-types";

/**
 * Common form functions forming a form base
 * Write named functions and need to bind them at child level, otherwise "this" binding fails
 *
 * Tried building a HOC before finalizing inheritance pattern.
 */
class FormBase extends Component {
  componentDidMount() {
    this.handleFormChange();
  }
  showError = elem => (elem.touched && elem.valid);
  // Should be overriden by children
  formatData = () => {}
  runFormValidation() {
    const updatedFormElement = {
      ...this.state
    };
    for (const inputIdentifier of Object.keys(updatedFormElement)) {
      if (updatedFormElement[inputIdentifier]
        && updatedFormElement[inputIdentifier].validationRules 
        && Object.keys(updatedFormElement[inputIdentifier].validationRules).length) {
          updatedFormElement[inputIdentifier].valid = validate(updatedFormElement[inputIdentifier].value, updatedFormElement[inputIdentifier].validationRules, this.state);
          updatedFormElement[inputIdentifier].touched = true;
      }
    }
    this.setState({
      ...updatedFormElement
    });
  }

  handleBlur(event) {
    const { name, value } = event.target;
    const updatedFormElement = {
      ...this.state[name]
    };
    updatedFormElement.touched = true;
    updatedFormElement.valid = validate(value, updatedFormElement.validationRules, this.state);
    this.setState({
      [name]: updatedFormElement
    }, () => this.handleBlurChange && this.handleBlurChange());
  }

  // For text input
  handleInputChange(event) {
    const { name, value } = event.target;
    const updatedFormElement = {
      ...this.state[name]
    };
    const matched = updatedFormElement.matchPattern
      ? updatedFormElement.matchPattern.test(value) : true;
    if (matched) {
      updatedFormElement.value = value;
      updatedFormElement.touched = true;
      updatedFormElement.valid = "";
      this.setState({
        [name]: updatedFormElement
      }, this.handleFormChange);
    }
  }

  // For Select/Dropdowns
  handleSelectChange(value, targetName) {
    const name = targetName;
    const updatedFormElement = {
      ...this.state[name]
    };
    updatedFormElement.value = value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = "";
    this.setState({
      [name]: updatedFormElement
    }, this.handleFormChange);
  }

  // For text input
  handleCheckboxChange(event) {
    const { name, checked } = event.target;
    const updatedFormElement = {
      ...this.state[name]
    };
    updatedFormElement.value = checked;
    updatedFormElement.touched = true;
    updatedFormElement.valid = "";
    this.setState({
      [name]: updatedFormElement
    }, this.handleFormChange);
  }

  checkFormValid(state) {
    let formIsValid = true;
    for (let inputIdentifier of Object.keys(state)) {
      if (state[inputIdentifier] 
        && state[inputIdentifier].validationRules 
        && Object.keys(state[inputIdentifier].validationRules).length) {
          formIsValid = !validate(state[inputIdentifier].value, state[inputIdentifier].validationRules, state) && formIsValid;
      }
    }
    return formIsValid;
  }

  handleFormChange() {
    this.props.handleFormChange(this.formatData());
  }
}

FormBase.propTypes = {
  handleFormChange: PropTypes.func
}

export default FormBase;
